import React, { memo, useCallback, useEffect, useState } from "react";
import Logo from "../components/Logo";
import telegram from "../assets/images/telegram.svg";
import telegramWite from "../assets/images/telegramWite.svg";
import instagram from "../assets/images/instagram.png";
import { Link, useLocation } from "react-router-dom";
import AntiCounterfeitQuery from "../components/AntiCounterfeitQuery/AntiCounterfeitQuery";
import YandexMap from "../pages/YandexMap/map";
import { addresses } from "../pages/YandexMap/addresses";
import "./styles.css";

const MOSCOW_COORDS = [55.751244, 37.618423];

const Layout = memo(({ children }) => {
  const [mapHeight, setMapHeight] = useState(500);
  const [userCoords, setUserCoords] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const applyHeight = () => setMapHeight(mq.matches ? 700 : 500);
    applyHeight();
    mq.addEventListener("change", applyHeight);
    return () => mq.removeEventListener("change", applyHeight);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!menuOpen) return undefined;

    const onKeyDown = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    document.body.classList.add("menu-open");
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.classList.remove("menu-open");
    };
  }, [menuOpen]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (p) => setUserCoords([p.coords.latitude, p.coords.longitude]),
        () => setUserCoords(MOSCOW_COORDS)
      );
    } else setUserCoords(MOSCOW_COORDS);
  }, []);

  return (
    <div className="page-wrapper">
      {/* Single background color */}
      <div className="bg-layer bg-constant"></div>

      <header className="header">
        <div className="header-inner">
          <div className="logo-section">
            <Link to="/" onClick={closeMenu}>
              <Logo className="logo-size" />
            </Link>
            <Link to="/code23" className="code-link">
              CODE 23
            </Link>
            <Link to="/code46" className="code-link">
              CODE 46
            </Link>
            <Link to="/code190" className="code-link">
              CODE 30/55
            </Link>
          </div>

          <div className="header-actions">
            <nav className="social-nav">
              <a
                href="https://t.me/infocodesex"
                target="_blank"
                rel="noopener noreferrer"
                className="tg-link"
              >
                <img src={telegramWite} alt="tg" className="tg-icon" />
                <span className="tg-text">Telegram канал</span>
              </a>
            </nav>

            <button
              type="button"
              className={`menu-toggle${menuOpen ? " is-open" : ""}`}
              aria-label={menuOpen ? "Закрыть меню" : "Открыть меню"}
              aria-expanded={menuOpen}
              aria-controls="mobile-menu"
              onClick={() => setMenuOpen((open) => !open)}
            >
              <span className="menu-bar" />
              <span className="menu-bar" />
              <span className="menu-bar" />
            </button>
          </div>
        </div>

        <div
          id="mobile-menu"
          className={`mobile-menu${menuOpen ? " is-open" : ""}`}
          hidden={!menuOpen}
        >
          <nav className="mobile-menu-nav">
            <Link to="/code23" className="mobile-menu-link" onClick={closeMenu}>
              CODE 23
            </Link>
            <Link to="/code46" className="mobile-menu-link" onClick={closeMenu}>
              CODE 46
            </Link>
            <Link to="/code190" className="mobile-menu-link" onClick={closeMenu}>
              CODE 30/55
            </Link>
          </nav>

          <a
            href="https://t.me/infocodesex"
            target="_blank"
            rel="noopener noreferrer"
            className="mobile-menu-tg"
            onClick={closeMenu}
          >
            <img src={telegramWite} alt="" className="tg-icon" />
            <span>Telegram канал</span>
          </a>
        </div>
      </header>

      <main className="main-content">{children}</main>

      {userCoords && (
        <YandexMap
          apiKey={process.env.REACT_APP_YMAPS_KEY}
          items={addresses}
          height={mapHeight}
          width={500}
          defaultCenter={userCoords}
          defaultZoom={userCoords === MOSCOW_COORDS ? 8 : 10}
        />
      )}

      <footer className="footer">
        <div className="footer-container">
          <a href="mailto:info@code.sex" className="footer-email">
            info@code.sex
          </a>

          <div className="footer-socials">
            <a className="social-circle" rel="noreferrer" href="https://t.me/infocodesex" target="_blank">
              <img src={telegram} className="social-icon" alt="tg" />
            </a>

            <a className="social-circle" rel="noreferrer" href="https://www.instagram.com/code.sex.russia?igsh=YXhzcXEydXh1dGI2" target="_blank">
              <img src={instagram} className="social-icon" alt="inst" />
            </a>
          </div>

          <AntiCounterfeitQuery />

          <p className="footer-text">© {new Date().getFullYear()} CODE.</p>
        </div>
      </footer>
    </div>
  );
});

export default Layout;
